import { render, staticRenderFns } from "./ChargeNeopag.vue?vue&type=template&id=3a5ac407&scoped=true&"
import script from "./ChargeNeopag.vue?vue&type=script&lang=js&"
export * from "./ChargeNeopag.vue?vue&type=script&lang=js&"
import style0 from "./ChargeNeopag.vue?vue&type=style&index=0&id=3a5ac407&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ac407",
  null
  
)

export default component.exports